import { useState, useEffect } from "react";
import Button from "../../ui/Button";
import Input from "../../ui/Input";
import Select from "../../ui/Select";
import { useUser, useCreateLead, useUpdateLead, useTotalStaff, } from "../../Use-auth";
import { useLocation } from "wouter";
import PhoneInput from 'react-phone-input-2';
import "react-phone-input-2/lib/style.css";

const COUNTRIES = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "UAE",
  "Uganda",
  "Ukraine",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];

export default function CreateLead({ editingLead, setEditingLead, onDone, setActiveTab, leadsType }) {
    const { data: user } = useUser();
    const createLead = useCreateLead();
    const updateLead = useUpdateLead();
    const [errors, setErrors] = useState({});
    const { data: employees } = useTotalStaff();
    const [, setLocation] = useLocation();
    const [showProjectInfo, setShowProjectInfo] = useState(!editingLead);
    const managerSendRequest = Array.isArray(employees)
        ? employees.flatMap((emp) => emp?.employees || [])
        : [];

    const managerData = managerSendRequest.filter(
        (emp) => emp && emp.department === "Management"
    );
    const managerInfo = managerData?.map((mgr) => ({
        userId: mgr.employeeId,
        email: mgr.officeEmail,
        userName: `${mgr.firstName} ${mgr.lastName}`,
    })) || [];

    const leadName = user?.fullName || "";

    useEffect(() => {
        if (leadName) {
            setForm((prev) => ({
                ...prev,
                leadOwner: leadName,
            }));
        }
    }, [leadName]);

    useEffect(() => {
        if (editingLead) {
            setForm({
                ...editingLead,
                ...editingLead.address
            });
        }
    }, [editingLead]);

    useEffect(() => {
        setShowProjectInfo(!editingLead);
    }, [editingLead]);

    const [form, setForm] = useState({
        leadOwner: "",
        title: "",
        firstName: "",
        phone: "",
        leadSource: [],
        company: "",
        email: "",
        website: "",
        leadStatus: "",
        descrition: "",
        connectedTo: "",
        country: "",
        street: "",
        city: "",
        zip: "",
        timeZone: "",
        budget: "",
        rate: "",
        spentConnects: "",
        leadId: "",
        jobLink: "",
    });

    // useEffect(() => {
    //     const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

    //     setForm(prev => ({
    //         ...prev,
    //         timeZone: tz
    //     }));
    // }, []);

    const handleChange = (key) => (e) => {
        let value = e.target.value;

        if (key === "firstName" || key === "connectedTo") {
            value = value.replace(/[^a-zA-Z ]/g, "");
        }

        if (key === "phone" || key === "budget" || key === "spentConnects") {
            value = value.replace(/[^0-9]/g, "");
        }

        if (key === "timeZone") {
            value = value.toUpperCase();
        }

        if (key === "leadSource") {
            const value = e.target.value;

            setForm((prev) => {
                const alreadySelected = prev.leadSource.includes(value);

                return {
                    ...prev,
                    leadSource: alreadySelected
                        ? prev.leadSource.filter((v) => v !== value)
                        : [...prev.leadSource, value],
                };
            });

            return;
        }

        const maxLengths = {
            firstName: 50,
            connectedTo: 50,
            title: 100,
            phone: 15,
            budget: 10,
            website: 200,
            email: 100,
            company: 100,
            street: 100,
            city: 100,
            stateProvince: 100,
            zip: 10,
        };

        if (maxLengths[key]) {
            value = value.slice(0, maxLengths[key]);
        }

        setForm((prev) => ({ ...prev, [key]: value }));

        setErrors((prev) => ({
            ...prev,
            [key]: false
        }));
    };

    const leadRows = [
        [
            { key: "leadOwner", label: "Lead Owner" },
        ],
        [
            { key: "firstName", label: "Client Name" },
        ],
        [
            { key: "phone", label: "Phone" },
        ],
        [
            { key: "connectedTo", label: "Connected On" },
        ],
        [
            { key: "email", label: "Email" },
        ],
    ];

    const clientInformation = [
        [
            { key: "title", label: "Lead Title" },
            {
                key: "leadSource",
                label: "Lead Source",
                options: [
                    "Email Marketing",
                    "Direct Website",
                    "Referral",
                    "Upwork",
                    "LinkedIn",
                    "Google Search (Organic SEO)",
                    "Google Ads",
                    "Facebook",
                    "Instagram",
                    "YouTube",
                    "Newsletter Signups",
                    "Online Chat / Chatbot",
                    "WhatsApp Inquiry",
                    "Cold Calls",
                    "Cold Emails",
                    "Previous Clients",
                    "Pinterest",
                    "Threads",
                    "X",
                    "Reddit"
                ]
            }
        ],
        [
            { key: "company", label: "Company" },
            { key: "website", label: "Website" },
        ],
        [
            { key: "descrition", label: "Job Descrition", textarea: true },
            { key: "leadStatus", label: "Lead Status", className: "leadStatus-color", options: ["New", "Contacted", "Proposal Sent", "Qualified", "Won", "Lost"] },
        ],

        [
            { key: "leadId", label: "Lead Id" },
            { key: "jobLink", label: "Job Purposal Link" },
        ],

        [
            { key: "budget", label: "Budget USD ($)" },
            {
                key: "rate",
                label: "Contract Type",
                options: [
                    "Hourly",
                    "Fixed"
                ]
            },
        ],

        [
            { key: "spentConnects", label: "Spent Connects" },
        ],
    ];

    const addressRows = [
        [
            { key: "country", label: "Country / Region", options: COUNTRIES },
        ],
        [
            { key: "street", label: " Address" },
            { key: "city", label: "City" },
        ],
        [
            { key: "stateProvince", label: "State / Province" },
            { key: "zip", label: "Zip / Postal Code" },
        ],
        [
            {
                key: "timeZone",
                label: "Time Zone (e.g. GMT+8, PST, IST)",
            }
        ],
    ];

    const requiredFields = editingLead
        ? ["leadOwner", "country", "leadStatus"]
        : ["leadOwner", "title", "country", "leadStatus"]

    const statusColor = "text-blue-500";

    const renderField = ({ key, label, options, prefix, textarea }) => {
        const isRequired = requiredFields.includes(key);
        const labelText = isRequired ? `${label} *` : label;
        const isLeadOwner = key === "leadOwner";
        const hasError = errors[key];

        if (textarea) {
            return (
                <div key={key} className="flex flex-col gap-1">
                    <label className="text-sm font-medium">{labelText}</label>
                    <textarea
                        value={form[key]}
                        onChange={handleChange(key)}
                        placeholder={`Enter ${label}`}
                        disabled={isLeadOwner}
                        rows={3}
                        className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                        maxLength={50000}
                    />
                </div>
            );
        }

        if (key === "leadSource") {
            return (
                <div key={key}>
                    <label className="text-sm font-medium">{labelText}</label>

                    <div className="border rounded p-2 max-h-[120px] overflow-y-auto">
                        {options.map((opt) => (
                            <label key={opt} className="flex items-center gap-2 text-sm">
                                <input
                                    type="checkbox"
                                    value={opt}
                                    checked={form.leadSource.includes(opt)}
                                    onChange={handleChange(key)}
                                />
                                {opt}
                            </label>
                        ))}
                    </div>
                </div>
            );
        }

        if (options) {
            let disabledOptions = [];

            if (key === "leadStatus") {
                const currentStatus = editingLead ? editingLead.leadStatus : null;

                if (editingLead && currentStatus) {
                    if (currentStatus === "Qualified" || currentStatus === "Proposal Sent") {
                        disabledOptions = ["New", "Contacted"];
                    }
                    else if (currentStatus === "Won") {
                        disabledOptions = ["New", "Contacted", "Qualified", "Proposal Sent"];
                    }
                    else if (currentStatus === "Lost") {
                        disabledOptions = options;
                    }
                } else {
                    disabledOptions = options.filter(
                        opt => !["New", "Contacted"].includes(opt)
                    );
                }
            }
            const statusLabelColor =
                key === "leadStatus" ? statusColor : "";

            return (
                <Select
                    key={key}
                    value={form[key] || ""}
                    onChange={handleChange(key)}
                    label={labelText}
                    options={options}
                    disabledOptions={disabledOptions}
                    className={`${key === "leadStatus" ? "leadStatus-color" : ""} ${hasError ? "border-red-500" : ""}`}
                    labelClassName={statusLabelColor}
                />
            );
        }

        if (key === "phone") {
            return (
                <div key={key} className="flex flex-col gap-1">
                    <label className="text-sm font-medium">{labelText}</label>
                    <PhoneInput
                        country={'us'}
                        value={form[key]}
                        onChange={phone => setForm(prev => ({ ...prev, [key]: phone }))}
                        inputProps={{
                            name: key,
                            required: isRequired,
                            autoFocus: false,
                        }}
                        inputStyle={{
                            width: '100%',
                            height: '38px',
                            borderRadius: '6px',
                            border: '1px solid #d1d5db',
                        }}
                        containerStyle={{}}
                        buttonStyle={{}}
                    />
                </div>
            );
        }

        return (
            <Input
                key={key}
                value={form[key]}
                onChange={handleChange(key)}
                label={labelText}
                prefix={prefix}
                placeholder={`Enter ${label}`}
                disabled={isLeadOwner}
                inputClassName={hasError ? "border-red-500" : ""}
            />
        );
    };

    const resetForm = () => {
        setForm({
            leadOwner: leadName,
            title: "",
            firstName: "",
            phone: "",
            leadSource: "",
            company: "",
            email: "",
            website: "",
            leadStatus: "",
            connectedTo: "",
            descrition: "",
            country: "",
            street: "",
            city: "",
            zip: "",
            timeZone: "",
            budget: "",
            spentConnects: "",
            leadId: "",
            jobLink: "",
        });
    }

    const isValid = requiredFields.every((f) => form[f]);

    const redirectByStatus = (status) => {

        if (!user) {
            console.log("User not loaded yet");
            return;
        }

        if (!status) {
            console.log("No status");
            return;
        }

        const isAdminOrManager =
            user.department === "Admin" ||
            user.department === "Management";

        if (isAdminOrManager) {

            if (leadsType === "normalleads" && status === "Lost") {
                setActiveTab("normalleads");
                return;
            }

            if (["New", "Contacted"].includes(status)) {
                setActiveTab("leads");

            } else if (["Proposal Sent", "Qualified"].includes(status)) {
                setActiveTab("normalleads");

            } else if (["Won", "Lost"].includes(status)) {
                setActiveTab("wonleads");
            }

            return;
        }

        if (leadsType === "normalleads" && status === "Lost") return;

        if (["New", "Contacted"].includes(status)) {
            setLocation("/lead-contacts");

        } else if (["Proposal Sent", "Qualified"].includes(status)) {
            setLocation("/lead");

        } else if (["Won", "Lost"].includes(status)) {
            setLocation("/active-contacts");
        }
    };

    const handleSave = () => {
        const missing = requiredFields.filter((f) => !form[f]);
        if (missing.length) {
            const errorObj = {};
            missing.forEach((field) => {
                errorObj[field] = true;
            });
            setErrors(errorObj);
            return;
        }

        setErrors({});

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (form.email && !emailRegex.test(form.email)) {
            return alert("Please enter a valid email address");
        }

        const payload = {
            ...form,
            address: {
                country: form.country,
                flat: form.flat,
                street: form.street,
                city: form.city,
                stateProvince: form.stateProvince,
                zip: form.zip,
                timeZone: form.timeZone,
            },
            sendManger: managerInfo,
        };
        if (!editingLead) {
            const projectData = {
                title: form.title,
                leadSource: form.leadSource,
                company: form.company,
                website: form.website,
                descrition: form.descrition,
                budget: form.budget,
                rate: form.rate,
                spentConnects: form.spentConnects,
                leadId: form.leadId,
                jobLink: form.jobLink,
            };
            payload.projects = [projectData];
        }

        if (editingLead) {
            updateLead.mutate(
                {
                    leadId: editingLead._id,
                    ...payload,
                },
                {
                    onSuccess: () => {
                        const status = form.leadStatus;
                        resetForm();
                        redirectByStatus(status);
                        onDone();
                    },
                }
            );
        } else {
            createLead.mutate({
                userId: user.userId,
                userName: user.fullName,
                userEmail: user.email,
                leadData: payload
            }, {
                onSuccess: () => {
                    const status = form.leadStatus;
                    resetForm();
                    redirectByStatus(status);
                    onDone();
                },
            });
        }
    };

    // const handleCancel = () => {
    //     resetForm()
    // };

    return (
        <div>
            <div className="flex justify-end gap-4">
                <Button
                    disabled={createLead.isPending || updateLead.isPending}
                    onClick={handleSave}
                    variant="success"
                    className="flex items-center justify-center gap-2 "
                >
                    {createLead.isPending || updateLead.isPending ? (
                        <>
                            Saving...
                            <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                        </>
                    ) : (
                        "Save"
                    )}
                </Button>
            </div>
            <div>
                <h2 className="text-[16px] sm:text-[20px] font-bold border-b mb-4">Client Information</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                    {leadRows.map((row, i) => (
                        <div key={i} className="contents">
                            {row.map(renderField)}
                        </div>
                    ))}
                </div>
            </div>

            {showProjectInfo && (<div>
                <h2 className="text-[16px] sm:text-[20px] font-bold border-b mb-4">Project Information</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                    {clientInformation.map((row, i) => (
                        <div key={i} className="contents">
                            {row.map(renderField)}
                        </div>
                    ))}
                </div>
            </div>)}

            <h2 className="text-[16px] sm:text-[20px] font-bold border-b mb-4">Address Information</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-14">
                {addressRows.map((row, i) => (
                    <div key={i} className="contents">
                        {row.map(renderField)}
                    </div>
                ))}
            </div>
        </div>
    )
}
